const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const twitterPixelScript = `(function(e, t, n, s, u, a) {
    e.twq ||
      ((s = e.twq = function() {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments)
      }),
      (s.version = '1.1'),
      (s.queue = []),
      (u = t.createElement(n)),
      (u.async = !0),
      (u.src = '//static.ads-twitter.com/uwt.js'),
      (a = t.getElementsByTagName(n)[0]),
      a.parentNode.insertBefore(u, a))
  })(window, document, 'script')
  // Insert Twitter Pixel ID and Standard Event data below
  twq('init', 'nx9cg')
  twq('track', 'PageView')`

exports.onClientEntry = () => {
  const twitterPixelInit = () => {
    const script = document.createElement('script')
    script.id = 'gatsby-plugin-twitter-pixel'
    const inlineScript = document.createTextNode(twitterPixelScript)
    script.appendChild(inlineScript)
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  window.removeEventListener(cookieAcceptEventName, twitterPixelInit)
  window.addEventListener(cookieAcceptEventName, twitterPixelInit, {
    once: true,
  })

  if (hasAcceptedCookies('analytics')) {
    twitterPixelInit()
  }
}
